import { CLOSE_LABELS, HEALTH_LABELS, PHASE_LABELS, STATUS_LABELS, customerBadge, healthTone, phaseTone, statusTone } from "../../lib/customers";

function Pill({ tone, children, testid }) {
  return (
    <span className={`inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-medium whitespace-nowrap ${tone}`} data-testid={testid}>
      {children}
    </span>
  );
}

export function PhaseBadge({ phase }) {
  return <Pill tone={phaseTone(phase)} testid="customer-phase">{PHASE_LABELS[phase] || phase}</Pill>;
}

export function StatusBadge({ status, closeCode }) {
  const label = status === "terminated" && CLOSE_LABELS[closeCode] ? `Clos · ${CLOSE_LABELS[closeCode]}` : STATUS_LABELS[status] || status;
  return <Pill tone={statusTone(status)} testid="customer-status">{label}</Pill>;
}

// Health (07-3): the state, and a pencil mark when someone corrected it by hand. A closed account has none (« — »).
export function HealthBadge({ state, overridden = false, testid = "customer-health" }) {
  if (!state) return <span className="text-slate-400" data-testid={testid}>—</span>;
  return (
    <Pill tone={healthTone(state)} testid={testid}>
      {HEALTH_LABELS[state] || state}{overridden && <span className="ml-1" title="Correction manuelle" aria-label="corrigée à la main">✎</span>}
    </Pill>
  );
}

// The small « Client · … » mark next to a pharmacy (pipeline card, prospects list, global search). Nothing when no account is
// visible to the reader.
export function CustomerMark({ badge, className = "" }) {
  const mark = customerBadge(badge);
  if (!mark) return null;
  return (
    <span className={`inline-flex items-center rounded-full border px-1.5 py-px text-2xs font-medium whitespace-nowrap ${mark.tone} ${className}`}
      data-testid="customer-mark">
      {mark.label}
    </span>
  );
}
